/**
 * Copyright (C) 2017 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import LuiBase from '@here/lui-base'
import scopedCss from 'lui-overlay.scss'
import template from 'lui-overlay.html'

export default class LuiOverlay extends LuiBase {
  static get is() {
    return 'lui-overlay'
  }

  static get cssClassToggles() {
    return ['brand']
  }

  static get css() {
    return scopedCss
  }

  static get template() {
    return template
  }

  showModal() {
    console.warn('LuiOverlay.showModal is deprecated use LuiOverlay.show instead')
    this.show()
  }

  show() {
    function getVisibleScrollWidth() {
      return window.innerWidth - document.querySelector('html').clientWidth
    }

    // requestAnimationFrame is needed two times as the first opening of the
    // Overlay sometimes lacks the animation otherwise.
    requestAnimationFrame(() => {
      const body = document.querySelector('body')
      body.style.setProperty('--lui-scroll-width', `${getVisibleScrollWidth()}px`)
      body.classList.add('lui-scroll-hidden')
      this.style.display = 'block'
      requestAnimationFrame(() => {
        this.seedElement.setAttribute('open', '')
      })
    })
  }

  close() {
    this.seedElement.removeAttribute('open')
    this.delay(() => {
      const body = document.querySelector('body')
      body.style.setProperty('--lui-scroll-width', 0)
      body.classList.remove('lui-scroll-hidden')
      this.style.display = 'none'
    }, 200)
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-overlay/lui-overlay.js
// module id = 286
// module chunks = 0 1 28